$(document).ready(function () { 
    $('.js-directory-add-twitter-form').on('submit', function (e) {
        e.preventDefault()
        var formData = $('.js-directory-add-twitter-form').serialize()

        $.ajax({
            type: "GET",
            url: '/submit-twitter-account/?' + formData,
            dataType: 'JSON',
            success: function (data) {
                if (data.ok == true) {
                    $('.js-directory-add-twitter-form').empty().append('<br/><br/><br/><h2 style="color: green;">Submitted successfully</h2><p style="color: red;">We will send you a direct message, when you accept it we will add your account to the directory.</p>')
                } else {
                    $('.js-error-form-twitter-submit').empty().append(data.error)
                }
            }
        });
    })
})